// Automatic exclusions (spec 08 §4), in the same precedence as private.segment_recipients (Task 21).
import { SKIP_REASONS, type SkipReason } from "./types.ts";

export type RecipientFacts = {
  email: string | null | undefined;
  prospectStatus: string | null | undefined;
  suppressed: boolean;
  consentValid: boolean;
};

export const normalizeEmail = (e: string | null | undefined): string | null =>
  (e ?? "").trim().toLowerCase() || null;

export function classifyRecipient(f: RecipientFacts): SkipReason | null {
  if (!normalizeEmail(f.email)) return "no_email";
  if (f.suppressed) return "suppressed";
  if (f.prospectStatus === "do_not_call") return "do_not_call";
  if (!f.consentValid) return "no_consent";
  return null;
}

export type SegmentCounts = {
  total: number;
  eligible: number;
  excluded: Record<SkipReason, number>;
};

export function summarizeRecipients(
  reasons: readonly (SkipReason | null)[],
): SegmentCounts {
  const excluded = Object.fromEntries(
    SKIP_REASONS.map((r) => [r, 0]),
  ) as Record<SkipReason, number>;
  let eligible = 0;
  for (const r of reasons) {
    if (r === null) eligible++;
    else excluded[r]++;
  }
  return { total: reasons.length, eligible, excluded };
}
